module.exports = {
  test: {
    'test': 'test',
  },
}



// WEBPACK FOOTER //
// ./src/Language/Language/en_us.js